import type { IconProps } from './IconProps';

export const CoinMarketCapIcon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 16"
    fill="none"
    width={props.width ?? 16}
    height={props.height ?? 16}
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M13.831 9.55556C13.5532 9.72222 13.2199 9.77778 12.9977 9.61111C12.6643 9.44445 12.4977 9 12.4977 8.44445V6.66667C12.4977 5.83333 12.1643 5.22222 11.6088 5.05555C10.6643 4.77778 9.9421 5.94444 9.66432 6.38889L7.99765 9.11111V5.77778C7.99765 5 7.71988 4.55556 7.27543 4.44444C6.9421 4.33333 6.49765 4.38889 6.05321 5.05555L2.33099 11.0556C1.83099 10.1111 1.55321 9.05556 1.55321 7.94445C1.55321 4.33333 4.4421 1.38889 7.99765 1.38889C11.5532 1.38889 14.4421 4.38889 14.4421 8C14.4977 8.72222 14.2754 9.27778 13.831 9.55556ZM15.8865 8C15.8865 3.55556 12.331 0 7.99765 0C3.66432 0 0.108765 3.61111 0.108765 8C0.108765 12.3889 3.66432 16 7.99765 16C9.99765 16 11.8865 15.2222 13.3865 13.8333C13.6643 13.5556 13.7199 13.1111 13.4421 12.7778C13.1643 12.5 12.7199 12.4444 12.4421 12.7222C11.2754 13.8333 9.66432 14.5 8.05321 14.5C6.16432 14.5 4.4421 13.6667 3.21988 12.3333L6.60876 6.88889V9.38889C6.60876 10.6111 7.05321 11 7.4421 11.1111C7.83099 11.2222 8.4421 11.1667 9.05321 10.1111L10.8865 7.11111C10.9421 7 10.9977 6.94445 11.0532 6.83333V8.33333C11.0532 9.44444 11.4977 10.3333 12.2754 10.7778C12.9977 11.1667 13.8865 11.1667 14.6088 10.6667C15.4977 10.2778 15.9421 9.22222 15.8865 8Z"
      fill="currentColor"
    />
  </svg>
);
